// ==========================   actions  ==========================
export const FETCH_ONE_USER_INS_MEDIA = "FETCH_ONE_USER_INS_MEDIA";
export const RERESH_CURRENT_USER_INS_MEDIA = "RERESH_CURRENT_USER_INS_MEDIA";
export const ADD_INS_MEDIA_LIST = "ADD_INS_MEDIA_LIST";
export const REQUEST_CURRENT_INS_USER_MEDIA_MORE =
  "REQUEST_CURRENT_INS_USER_MEDIA_MORE";
export const REQUEST_ONE_MEDIA_INFO = "REQUEST_ONE_MEDIA_INFO";
export const SUPPLEMENT_INS_USER_MEDIA_LIST = "SUPPLEMENT_INS_USER_MEDIA_LIST";
export const CREATE_DEFAULT_INS_USER_MEDIA = "CREATE_DEFAULT_INS_USER_MEDIA";
export const RERESH_ONE_USER_INS_MEDIA = "RERESH_ONE_USER_INS_MEDIA";
// ==========================   mutations  ==========================
export const UPDATE_INS_MEDIA_LIST = "UPDATE_INS_MEDIA_LIST";
export const UPDATE_CURRENT_POST_INFO = "UPDATE_CURRENT_POST_INFO";
export const UPDATE_CURRENT_POST_ID = "UPDATE_CURRENT_POST_ID";
export const UPDATE_ONE_INS_POST_INFO = "UPDATE_ONE_INS_POST_INFO";
export const UPDATE_SEARCH_INS_POST_INFO = "UPDATE_SEARCH_INS_POST_INFO";
export const UPDATE_INS_USER_MEDIA_STATUS = "UPDATE_INS_USER_MEDIA_STATUS";
export const UPDATE_INS_MEDIA_LIST_INFO = "UPDATE_INS_MEDIA_LIST_INFO";
export const CLEAR_INS_USER_MEDIA_LIST = "CLEAR_INS_USER_MEDIA_LIST";
// ==========================   getters  ==========================
export const GETTER_CURRENT_USER_MEDIA_LIST = "GETTER_CURRENT_USER_MEDIA_LIST";
export const GETTER_CURRENT_POST_INFO = "GETTER_CURRENT_POST_INFO";
export const GETTER_ONE_USER_MEDIA = "GETTER_ONE_USER_MEDIA";
export const GETTER_CURRENT_POST_ID = "GETTER_CURRENT_POST_ID";
